import React, { useState, useEffect } from "react";
import { Alert, Button, Typography } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import RefreshIcon from "@mui/icons-material/Refresh";
import { useTheme } from "@mui/material/styles";
import getAllStore from "../../api/store/getAllStore";
import {
  DataGrid,
  zhTW,
  GridToolbarContainer,
  GridActionsCellItem,
} from "@mui/x-data-grid";
import AddStoreDialog from "./component/AddStoreDialog";
import { formatLoveCodeLabel } from "../../invoiceUtils";

function StorePage() {
  const [open, setOpen] = useState(false);
  const [stores, setStores] = useState([]); // Initialize with your store data
  const [selectedStore, setSelectedStore] = useState({});
  const theme = useTheme();
  const [isAdd, setIsAdd] = useState(false);
  const [error, setError] = useState(null);

  const fetchStores = async () => {
    setError(null);
    try {
      const data = await getAllStore();
      if (data.code !== "000" || !Array.isArray(data.stores || [])) {
        throw new Error(data.message || "店家資料載入失敗，請重新刷新。");
      }
      setStores(data.stores || []);
    } catch (err) {
      setError(err.message || "店家資料載入失敗，請重新刷新。");
    }
  };

  useEffect(() => {
    fetchStores();
  }, []);

  function EditToolbar() {
    const handleAddClick = () => {
      setIsAdd(true);
      setOpen(true);
    };

    const handleRefreshClick = () => {
      fetchStores();
    };

    return (
      <GridToolbarContainer>
        <Button color="info" startIcon={<AddIcon />} onClick={handleAddClick}>
          新增店家
        </Button>
        <Typography>|</Typography>
        <Button color="info" startIcon={<RefreshIcon />} onClick={handleRefreshClick}>
          刷新
        </Button>
      </GridToolbarContainer>
    );
  }

  const handleEditClick = (id) => () => {
    setIsAdd(false);
    setSelectedStore(stores.find((store) => store.Code === id));
    setOpen(true);
  };

  const columns = [
    {
      field: "操作",
      type: "actions",
      headerName: "操作",
      width: 70,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
        ];
      },
    },
    { field: "Code", headerName: "店號", width: 100 },
    { field: "ImaoStoreCode", headerName: "發票店號", width: 110 },
    { field: "InvoiceEnable", headerName: "啟用發票", type: "boolean", width: 100 },
    {
      field: "InvoiceLoveCodes",
      headerName: "愛心碼",
      width: 260,
      valueGetter: ({ row }) =>
        (row.InvoiceLoveCodes || [])
          .map((code) => formatLoveCodeLabel(code, row.InvoiceLoveCodeNames))
          .join(", "),
    },
    { field: "Name", headerName: "名稱", width: 130 },
    { field: "City", headerName: "城市", width: 130 },
    { field: "Address", headerName: "地址", width: 130 },
    { field: "Status", headerName: "狀態", width: 130 },
    { field: "HideFromWeb", headerName: "前台隱藏", type: "boolean", width: 100 },
    { field: "Phone", headerName: "電話", width: 130 },
    {
      field: "IsValid",
      headerName: "有效",
      type: "bool",
      width: 110,
    },
  ];

  return (
    <>
      {error && <Alert severity="error" sx={{ mb: 1 }}>{error}</Alert>}
      <div style={{ height: 600, width: "100%" }}>
        <DataGrid
          localeText={zhTW.components.MuiDataGrid.defaultProps.localeText}
          rows={stores || []}
          columns={columns}
          disableColumnSelector
          disableRowSelectionOnClick
          sx={{ color: theme.palette.text.primary }}
          getRowId={(row) => row.Code}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 10 },
            },
          }}
          slots={{
            toolbar: EditToolbar,
          }}
          slotProps={{
            toolbar: {},
          }}
          pageSizeOptions={[10, 20]}
        />
      </div>
      <AddStoreDialog
        isAdd={isAdd}
        store={selectedStore}
        open={open}
        setOpen={setOpen}
        onSaved={fetchStores}
      ></AddStoreDialog>
    </>
  );
}

export default StorePage;
